module.exports = __webpack_public_path__ + "img/git.85a13266.png";